import { BasicBooking } from '../../../common/graphql/fragments/gql/BasicBooking';

export const isBookingEditable = (booking: BasicBooking) => {
  const bookingHasEditableFields = booking.editableFields.length > 0;
  return booking.editable || bookingHasEditableFields;
};
